'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _components = require('components');

var _mozart_ui = require('@pgforsta/mozart_ui');

var _survey = require('redux/modules/survey');

var _utilElement = require('utils/util-element.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Surveys = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    surveys: state.survey.list,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadSurveys: _survey.loadSurveys }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Surveys, _Component);

  function Surveys(props) {
    (0, _classCallCheck3.default)(this, Surveys);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Surveys.scss');
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      selected_survey: _this.props.selectedSurvey,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading surveys listing page.');
    return _this;
  }

  Surveys.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.surveys) {
      this.props.loadSurveys(this.props.clientId, this.props.locationId);
    }
  };

  Surveys.prototype.setSurvey = function setSurvey(survey) {
    this.setState({ selected_survey: survey.id });
    this.props.onSelectSurvey(survey);
  };

  Surveys.prototype.getSingleSurvey = function getSingleSurvey(survey) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 6, md: 6, lg: 6 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: survey.name, className: this.state.selected_survey === survey.id ? this.styles.survey_container + ' ' + this.styles.survey_selected : this.styles.survey_container, onClick: this.setSurvey.bind(this, survey) },
        _react2.default.createElement(
          'div',
          { className: this.styles.survey_name },
          _react2.default.createElement('span', { className: 'icon-BFSurvey ' + this.styles.survey_icon }),
          survey.name
        )
      )
    );
  };

  Surveys.prototype.getSurveys = function getSurveys() {
    var _this2 = this;

    var _props = this.props,
        surveys = _props.surveys,
        previewMode = _props.previewMode;

    var surveyElem = [];
    if (surveys && surveys.data.length) {
      surveys.data.map(function (item) {
        if (previewMode) {
          if (_this2.state.search_text) {
            if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
              surveyElem.push(_this2.getSingleSurvey(item));
            }
          } else {
            surveyElem.push(_this2.getSingleSurvey(item));
          }
        } else if (item.mobileFriendly) {
          if (_this2.state.search_text) {
            if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
              surveyElem.push(_this2.getSingleSurvey(item));
            }
          } else {
            surveyElem.push(_this2.getSingleSurvey(item));
          }
        }
      });
    } else {
      surveyElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_survey },
        'There are no surveys that have been set up for the practice/location at the moment. Please check back later or contact your practice/brand for assistance.'
      ));
    }
    if (!surveyElem.length) {
      surveyElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_survey },
        'Sorry ! no items found.'
      ));
    }
    return surveyElem;
  };

  Surveys.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Surveys.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('div', { className: 'masking_div' }),
      _react2.default.createElement(
        'div',
        { className: this.styles.surveys_page_container, style: { width: '100%' }, id: 'surveys_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.survey_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.survey_heading },
                    'Please select a survey'
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 6, md: 6, lg: 6, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_list_container, 'data-qa-type': 'list_container' },
                this.getSurveys()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.survey_heading },
                    'Search a survey'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.survey_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Surveys;
}(_react.Component), _class2.propTypes = {
  onSelectSurvey: _react.PropTypes.func,
  loadSurveys: _react.PropTypes.func,

  surveys: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedSurvey: _react.PropTypes.number,

  clientId: _react.PropTypes.string,
  locationId: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool,
  previewMode: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Surveys;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Surveys/Surveys.js
// module id = 2334
// module chunks = 0